import { Box } from '@chakra-ui/react';
import DatePicker from 'react-datepicker';
import { useTranslation } from 'react-i18next';

interface TexasDatePickerProps {
  selectedDate: Date | null;
  isClearable?: boolean;
  onDateChange: (date: Date | null) => void;
}

export function TexasDatePicker({
  selectedDate,
  isClearable = true,
  onDateChange,
}: TexasDatePickerProps) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        '.datepicker-input': {
          bg: 'texas.bg.800',
          px: 3,
          py: 5,
          borderBottom: '2px solid',
          borderBottomColor: 'gray.600',
          borderRadius: 'none',
          color: 'white',
          height: 8,
          _placeholder: {
            color: 'gray.200',
          },
          transition: 'border-color 200ms ease',
          _focus: {
            borderBottomColor: 'texas.sand.100',
          },
          _light: {
            color: 'black',
            bg: 'gray.10',
            _placeholder: {
              color: 'gray.400',
            },
            borderBottomColor: 'gray.100',
            _focus: {
              borderBottomColor: 'texas.burntSienna.100',
            },
          },
        },
      }}
    >
      <DatePicker
        selected={selectedDate}
        clearButtonClassName="react-date-picker-close-warning-comp"
        onChange={onDateChange}
        dateFormat="yyyy-MM-dd"
        placeholderText={t('filter.selectDate')}
        inline={false}
        isClearable={isClearable}
        calendarStartDay={1}
        className="datepicker-input"
      />
    </Box>
  );
}
